export default {
    'en': `English`,
    'et': `Eesti`,
    'fi': `Suomi`,
    'lt': `Lietuvių`,
    'lv': `Latviešu`,
    'sv': `Svenska`,
}
